/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-self-assign */
import { useEffect, useState } from "react";
import styled from "styled-components";
import confetti from "canvas-confetti";
import * as anchor from "@project-serum/anchor";
import {
  LAMPORTS_PER_SOL,
  PublicKey,
} from "@solana/web3.js";
import { useAnchorWallet } from "@solana/wallet-adapter-react";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import { GatewayProvider } from "@civic/solana-gateway-react";
import Countdown from "react-countdown";
import { Snackbar, Paper, LinearProgress } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { toDate, AlertState, getAtaForMint } from "./utils";
import { MintButton } from "./MintButton";
import {
  CandyMachine,
  awaitTransactionSignatureConfirmation,
  getCandyMachineState,
  mintOneToken,
  CANDY_MACHINE_PROGRAM,
} from "./candy-machine";
import {
  getParsedNftAccountsByOwner,
  isValidSolanaAddress,
  createConnectionConfig,
} from "@nfteyez/sol-rayz";
import { db } from "./resources/firebaseConfig";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  doc,
  getDoc,
  setDoc,
} from "firebase/firestore";
import "./Home.css"
import Button from "@material-ui/core/Button";
import { SocialIcon } from "react-social-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import Slide from "./components/Slider/Slide";
import Footer from "./components/Footer/Footer";


const cluster = process.env.REACT_APP_SOLANA_NETWORK!.toString();
const decimals = process.env.REACT_APP_SPL_TOKEN_TO_MINT_DECIMALS
  ? +process.env.REACT_APP_SPL_TOKEN_TO_MINT_DECIMALS!.toString()
  : 9;
const splTokenName = process.env.REACT_APP_SPL_TOKEN_TO_MINT_NAME
  ? process.env.REACT_APP_SPL_TOKEN_TO_MINT_NAME.toString()
  : "TOKEN";


const WalletContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  
`;

const WalletAmount = styled.div`
  color: var(--main-text-color);
  width: auto;
  padding: 0 0 0 8px;
  min-width: 48px;
  min-height: auto;
  border-radius: 35px;
  background-color: var(--main-background-color);
  box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%);
  box-sizing: border-box;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-weight: 400;
  line-height: 1.75;  
  border: 2px solid;
  margin: 0;
  display: inline-flex;
  outline: 0;
  position: relative;
  align-items: center;
  user-select: none;
  vertical-align: middle;
  justify-content: flex-start;
  gap: 4px;
  
`;

const Wallet = styled.ul`
  flex: 0 0 auto;
  margin: 0;
  padding: 0;
`;

const ConnectButton = styled(WalletMultiButton)`
  border-radius: 30px !important;
  padding: 6px 16px;
  background-color: var(--main-text-color);
  color: var(--main-background-color);
  margin: 0 auto;
  font-family: 'Söhne Breit Half';
`;

export const BuyButtonCont = styled.a`
  text-decoration:none;
`;

export const BuyButton = styled(Button)`
  display: block !important;
  margin: 0 auto !important;  
  background-color: var(--main-text-color) !important ;
  color: var(--main-background-color) !important;
  border: 2px solid !important;
  max-width: 280px !important;
  font-size: 1.2em !important;
  border-radius: 40px !important;
  font-family: 'Söhne Breit Half' !important;
  letter-spacing:0em !important;

  button:hover,
  button:focus {
    -webkit-animation: pulse 1s;
    animation: pulse 1s;
    box-shadow: 0 0 0 2em rgba(255, 255, 255, 0);
    color: var(--main-text-color) !important;
    background: var(--main-background-color) !important;
  }

  @-webkit-keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 var(--main-text-color);

    }
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 var(--main-text-color);
    }
  }
`;

const NFT = styled(Paper)`

  padding: 5px 20px 20px 20px;
  flex: 1 1 auto;
  background-color: var(--card-background-color) !important;
  

`;
const Des = styled(NFT)`
  text-align: justify;
  padding-top: 0px;
  font-size: 1em;
  font-family: 'Söhne';
  line-height: 1.6; 

  @media only screen and (max-width: 1540px){    
    font-size: 0.9em;
    line-height: 1.4;
  }
  @media only screen and (max-width: 1240px){    
    text-align: center ;
    font-size: 0.9em;
    line-height: 1.6;
  }
  @media only screen and (max-width: 1020px){    
    text-align: center ;
    font-size: 0.8em;
  }
`;

const Card = styled(Paper)`
  display: inline-block;
  background-color: var(--card-background-lighter-color) !important;
  margin: 2px;
  padding: 18px;
  font-family: 'Söhne Breit Half';
  font-size: 1em;
  color: var(--main-text-color) !important;
`;

const MintButtonContainer = styled.div`
  button.Mui-disabled {
    color: #464646;
  }

  button:hover,
  button:focus {
    -webkit-animation: pulse 1s;
    animation: pulse 1s;
    box-shadow: 0 0 0 2em rgba(255, 255, 255, 0);
    color: var(--main-text-color) !important;
    background: var(--main-background-color) !important;
  }

  @-webkit-keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 var(--main-text-color);

    }
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 var(--main-text-color);
    }
  }
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: right;
  margin-top : 60px;
  margin-bottom : 20px;
  padding-left: 30px;
  padding-right: 30px;
  color: var(--title-text-color);
  font-family: 'Söhne Breit Half';
  @media only screen and (max-width: 900px){    
    justify-content: center;
   
}
    
  
`;

const Logo = styled.div`
  

  img {
    height: 52px;
  }
`;
const Menu = styled.ul`
  list-style: none;
  display: inline-flex;
  flex: 1 0 auto;

  li {
    margin: 0 12px;

    a {
      color: var(--main-text-color);
      list-style-image: none;
      list-style-position: outside;
      list-style-type: none;
      outline: none;
      text-decoration: none;
      text-size-adjust: 100%;
      touch-action: manipulation;
      transition: color 0.3s;
      padding-bottom: 15px;

      img {
        max-height: 26px;
      }
    }

    a:hover, a:active {
      color: rgb(131, 146, 161);
      border-bottom: 4px solid var(--title-text-color);
    }

  }
`;

const SolExplorerLink = styled.a`
  color: var(--title-text-color);
  
  font-weight: bold;
  list-style-image: none;
  list-style-position: outside;
  list-style-type: none;
  outline: none;
 
  text-size-adjust: 100%;

  :hover {
    color: var(--main-text-color);
  }
`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-right: 4%;
  margin-left: 4%;
  text-align: center;
  justify-content: center;

  @media only screen and (max-width: 500px){    
  margin-right: 1%;
  margin-left: 1%;
  }
  
`;

const MintContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  flex-wrap: wrap;  
  align-items: center;

  @media only screen and (min-width: 1240px){ 
  margin-top: 90px;
  margin-bottom: 80px;
  }

`;

const DesContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  

  @media only screen and (min-width: 1240px){    
    max-width: 50%;
}
  @media only screen and (min-width: 1650px){    
    max-width: 60%;
}
`;


const Image = styled.img`
  height: 300px;
  width: auto;
  border-radius: 7px;
  box-shadow: 5px 5px 40px 5px #3838387e;

  @media only screen and (min-width: 500px){    
    height: 340px;
  }

  @media only screen and (min-width: 700px){    
    height: 440px;
  }

  @media only screen and (min-width: 1020px){    
    height: 480px;
  }
  
`;

const BorderLinearProgress = styled(LinearProgress)`
  margin: 20px 0;
  height: 8px !important;
  border-radius: 30px;
  border: 1px solid white;
  box-shadow: 5px 5px 40px 5px rgba(0,0,0,0.5);
  background-color:var(--main-text-color) !important;
  
  > div.MuiLinearProgress-barColorPrimary{
    background-color:#7a7a7a !important;
  }

  > div.MuiLinearProgress-bar1Determinate {
    border-radius: 30px !important;
    background-image: linear-gradient(270deg, rgba(255, 255, 255, 0.01), rgba(255, 255, 255, 0.5));
  }
`;

const ShimmerTitle = styled.h1`
  margin-top: 20px ;
  font-family: 'Söhne Breit Half';
  text-transform: uppercase;
  animation: glow 2s ease-in-out infinite alternate;
  color: var(--main-text-color);
  font-size: 3em;
  line-height: 2 ;
  @keyframes glow {
    from {
      text-shadow: 0 0 2px var(--main-text-color);
    }
    to {
      text-shadow: 0 0 5px var(--title-text-color), 0 0 2px var(--title-text-color);
    }
  }
`;
const Social = styled.div`
display: flex;
column-gap: 1rem;
justify-content: center;
margin-left:20px;

@media only screen and (max-width: 900px){    
    margin-bottom: 60px;
    margin-top: 20px;
    margin-left:0px;
}
`;

export interface HomeProps {
  candyMachineId: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  txTimeout: number;
  rpcHost: string;
  network: WalletAdapterNetwork;
}

const Home = (props: HomeProps) => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const [balance, setBalance] = useState<number>();
  const [isMinting, setIsMinting] = useState(false); // true when user got to press MINT
  const [isActive, setIsActive] = useState(false); // true when countdown completes or whitelisted
  const [solanaExplorerLink, setSolanaExplorerLink] = useState<string>("");
  const [itemsAvailable, setItemsAvailable] = useState(0);
  const [itemsRedeemed, setItemsRedeemed] = useState(0);
  const [itemsRemaining, setItemsRemaining] = useState(0);
  const [isSoldOut, setIsSoldOut] = useState(false);
  const [payWithSplToken, setPayWithSplToken] = useState(false);
  const [price, setPrice] = useState(0);
  const [priceLabel, setPriceLabel] = useState<string>("SOL");
  const [whitelistPrice, setWhitelistPrice] = useState(0);
  const [whitelistEnabled, setWhitelistEnabled] = useState(false);
  const [isBurnToken, setIsBurnToken] = useState(false);
  const [whitelistTokenBalance, setWhitelistTokenBalance] = useState(0);
  const [isEnded, setIsEnded] = useState(false);
  const [endDate, setEndDate] = useState<Date>();
  const [isPresale, setIsPresale] = useState(false);
  const [isWLOnly, setIsWLOnly] = useState(false);
  const [isBuyFirst, setIsBuyFirst] = useState(false);
  const [nixWallet, setNixWallet] = useState([]);
  const [isTotalMint, setIsTotalMint] = useState("");
  const [getTotalPass, setgetTotalPass] = useState(0);

  const [alertState, setAlertState] = useState<AlertState>({
    open: false,
    message: "",
    severity: undefined,
  });
  const walletNetwork = WalletAdapterNetwork.Mainnet;
  const wallet = useAnchorWallet();
  const [candyMachine, setCandyMachine] = useState<CandyMachine>();

  const rpcUrl = props.rpcHost;
  // const nixWalletColRef = collection(db, "nixWallet");

  const refreshCandyMachineState = () => {
    (async () => {
      if (!wallet) return;

      const cndy = await getCandyMachineState(
        wallet as anchor.Wallet,
        props.candyMachineId,
        props.connection
      );

      setCandyMachine(cndy);
      setItemsAvailable(cndy.state.itemsAvailable);
      setItemsRemaining(cndy.state.itemsRemaining);
      setItemsRedeemed(cndy.state.itemsRedeemed);

      var divider = 1;
      if (decimals) {
        divider = +("1" + new Array(decimals).join("0").slice() + "0");
      }

      const colRefget = doc(db, process.env.REACT_APP_FIREBASE_COLLECTION, wallet.publicKey.toBase58());
      const recordget = await getDoc(colRefget);

      // detect if using spl-token to mint
      if (cndy.state.tokenMint) {
        setPayWithSplToken(true);
        // Customize your SPL-TOKEN Label HERE
        // TODO: get spl-token metadata name
        setPriceLabel(splTokenName);
        setPrice(cndy.state.price.toNumber() / divider);
        setWhitelistPrice(cndy.state.price.toNumber() / divider);
      } else {
        setPrice(cndy.state.price.toNumber() / LAMPORTS_PER_SOL);
        setWhitelistPrice(cndy.state.price.toNumber() / LAMPORTS_PER_SOL);
      }

      // fetch whitelist token balance
      if (cndy.state.whitelistMintSettings) {
        setWhitelistEnabled(true);
        setIsBurnToken(cndy.state.whitelistMintSettings.mode.burnEveryTime);
        setIsPresale(cndy.state.whitelistMintSettings.presale);
        setIsWLOnly(
          !isPresale && cndy.state.whitelistMintSettings.discountPrice === null
        );

        if (
          cndy.state.whitelistMintSettings.discountPrice !== null &&
          cndy.state.whitelistMintSettings.discountPrice !== cndy.state.price
        ) {
          if (cndy.state.tokenMint) {
            setWhitelistPrice(
              cndy.state.whitelistMintSettings.discountPrice?.toNumber() /
              divider
            );
          } else {
            setWhitelistPrice(
              cndy.state.whitelistMintSettings.discountPrice?.toNumber() /
              LAMPORTS_PER_SOL
            );
          }
        }

        let balance = 0;
        try {
          const tokenBalance = await props.connection.getTokenAccountBalance(
            (
              await getAtaForMint(
                cndy.state.whitelistMintSettings.mint,
                wallet.publicKey
              )
            )[0]
          );

          balance = tokenBalance?.value?.uiAmount || 0;
        } catch (e) {
          console.error(e);
          balance = 0;
        }
        setWhitelistTokenBalance(balance);
        setIsActive(isPresale && !isEnded && balance > 0);
      } else {
        setWhitelistEnabled(false);
      }

      // end the mint when date is reached
      if (cndy?.state.endSettings?.endSettingType.date) {
        setEndDate(toDate(cndy.state.endSettings.number));
        if (
          cndy.state.endSettings.number.toNumber() <
          new Date().getTime() / 1000
        ) {
          setIsEnded(true);
          setIsActive(false);
        }
      }
      // end the mint when amount is reached
      if (cndy?.state.endSettings?.endSettingType.amount) {
        let limit = Math.min(
          cndy.state.endSettings.number.toNumber(),
          cndy.state.itemsAvailable
        );
        setItemsAvailable(limit);
        if (cndy.state.itemsRedeemed < limit) {
          setItemsRemaining(limit - cndy.state.itemsRedeemed);
        } else {
          setItemsRemaining(0);
          cndy.state.isSoldOut = true;
          setIsEnded(true);
        }
      } else {
        setItemsRemaining(cndy.state.itemsRemaining);
      }

      if (recordget.exists()) {
        setIsTotalMint(recordget.data()["totalMintStock"]);
      }

      if (cndy.state.isSoldOut) {
        setIsActive(false);
      }
    })();
  };

  const renderGoLiveDateCounter = ({ days, hours, minutes, seconds }: any) => {
    return (
      <div>
        <Card elevation={1}>
          <h1>{days}</h1>Days
        </Card>
        <Card elevation={1}>
          <h1>{hours}</h1>
          Hours
        </Card>
        <Card elevation={1}>
          <h1>{minutes}</h1>Mins
        </Card>
        <Card elevation={1}>
          <h1>{seconds}</h1>Secs
        </Card>
      </div>
    );
  };

  const renderEndDateCounter = ({ days, hours, minutes }: any) => {
    let label = "";
    if (days > 0) {
      label += days + " days ";
    }
    if (hours > 0) {
      label += hours + " hours ";
    }
    label += minutes + 1 + " minutes left to MINT.";
    return (
      <div>
        <h3>{label}</h3>
      </div>
    );
  };

  function displaySuccess(mintPublicKey: any): void {
    let remaining = itemsRemaining - 1;
    setItemsRemaining(remaining);
    setIsSoldOut(remaining === 0);
    if (isBurnToken && whitelistTokenBalance && whitelistTokenBalance > 0) {
      let balance = whitelistTokenBalance - 1;
      setWhitelistTokenBalance(balance);
      setIsActive(isPresale && !isEnded && balance > 0);
    }
    setItemsRedeemed(itemsRedeemed + 1);
    const solFeesEstimation = 0.012; // approx
    if (!payWithSplToken && balance && balance > 0) {
      setBalance(
        balance -
        (whitelistEnabled ? whitelistPrice : price) -
        solFeesEstimation
      );
    }
    setSolanaExplorerLink(
      cluster === "devnet" || cluster === "testnet"
        ? "https://solscan.io/token/" + mintPublicKey + "?cluster=" + cluster
        : "https://solscan.io/token/" + mintPublicKey
    );
    throwConfetti();
  }

  function throwConfetti(): void {
    confetti({
      particleCount: 400,
      spread: 70,
      origin: { y: 0.6 },
    });
  }

  const getMintAddress = async () => {
    let anchorConnection = new anchor.web3.Connection(
      process.env.REACT_APP_SOLANA_RPC_HOST!
    );

    const nfts = await getParsedNftAccountsByOwner({
      publicAddress: wallet.publicKey.toBase58(),
      connection: anchorConnection,
      sanitize: false,
    });

    return nfts;
  };

  const onMint = async () => {
    try {
      setIsMinting(true);

      let getMint = await getMintAddress();
      let totalMint = 0;
      let first = 0;
      let second = 0;
      let third = 0;
      let firstTotal = 0;
      let secondTotal = 0;
      let thirdTotal = 0;
      let total = 0;
      let totalAvailableMint = 0;
      let stockMint = 0;

      if (getMint[0] !== undefined) {
        getMint.forEach(async (data) => {
          if (data.data.name.includes("Abstract Labs Inner Circle")) {
            first = first += 1;
          } else if (data.data.name.includes("Abstract Labs Centurion")) {
            second = second += 1;
          } else if (data.data.name.includes("Abstract Labs Standard")) {
            third = third += 1;
          }
        });
      }

      firstTotal = first * 10;
      secondTotal = second * 3;
      thirdTotal = third * 1;
      total = first + second + third;
      totalAvailableMint = firstTotal + secondTotal + thirdTotal;
      console.log(total);
      console.log(totalMint);

      if (wallet && candyMachine?.program && wallet.publicKey) {
        if (total !== 0) {
          // console.log("total :" + total);
          const mint = anchor.web3.Keypair.generate();
          const mintTxId = (
            await mintOneToken(candyMachine, wallet.publicKey, mint)
          )[0];

          let status: any = { err: true };
          if (mintTxId) {
            status = await awaitTransactionSignatureConfirmation(
              mintTxId,
              props.txTimeout,
              props.connection,
              "singleGossip",
              true
            );
          }

          if (!status?.err) {
            setAlertState({
              open: true,
              message: "Congratulations! Mint succeeded!",
              severity: "success",
            });
            console.log("mint success");

            // update front-end amounts
            displaySuccess(mint.publicKey);

            //get all document from database
            // const data = await getDocs(nixWalletColRef);
            // const spec = data.docs.map((doc) => ({
            //   ...doc.data(),
            //   id: doc.id,
            // }));
            // console.log(spec);

            var condition = false;
            console.log("wallet active : " + wallet.publicKey.toBase58());
            const colRefget = doc(db, process.env.REACT_APP_FIREBASE_COLLECTION, wallet.publicKey.toBase58());
            const recordget = await getDoc(colRefget);

            //Check if wallet address is available in database
            // if (spec !== undefined) {
            //   spec.forEach(async (data) => {
            if (recordget.exists()) {
              // console.log(
              //   "check wallet from login : " + wallet.publicKey.toBase58()
              // );
              // console.log(
              //   "check wallet from db : " + recordget.data()["walletAddress"]
              // );
              var check =
                recordget.data()["walletAddress"] ===
                wallet.publicKey.toBase58();
            }
            // var check =
            // data["walletAddress"] === wallet.publicKey.toBase58();
            if (check === true) {
              condition = true;
            }
            //   });
            // }

            console.log("final condition : " + condition);

            //get DocumentReference from collection database
            // const colRef = doc(db, process.env.REACT_APP_FIREBASE_COLLECTION, wallet.publicKey.toBase58());
            // const record = await getDoc(colRef);

            //add new mint address to database
            const addWalletToDb = async (
              walletAddress,
              firstPass,
              firstTotal,
              secondPass,
              secondTotal,
              thirdPass,
              thirdTotal,
              totalPass,
              totalMintStock,
              stockMint
            ) => {
              await setDoc(colRefget, {
                walletAddress: walletAddress,
                firstPass: firstPass,
                firstTotal: firstTotal,
                secondPass: secondPass,
                secondTotal: secondTotal,
                thirdPass: thirdPass,
                thirdTotal: thirdTotal,
                totalPass: totalPass,
                totalMintStock: totalMintStock,
                stockMint: stockMint,
              });
              console.log("create success");
            };

            //update totalMintStock if mint address was recorded in database
            const updateWalletToDb = async (
              recordTotal,
              recordStock,
              address
            ) => {
              const walletDoc = doc(db, process.env.REACT_APP_FIREBASE_COLLECTION, address);
              const newStock = {
                totalMintStock: recordTotal - 1,
                stockMint: recordStock + 1,
              };
              await updateDoc(walletDoc, newStock);
              console.log("update succeded");
            };

            //check if specific data is available
            if (condition === false) {
              addWalletToDb(
                wallet.publicKey.toBase58(),
                first,
                firstTotal,
                second,
                secondTotal,
                third,
                thirdTotal,
                total,
                totalAvailableMint,
                stockMint + 1
              );
              console.log("add wallet");
              console.log("minting success");
            } else {
              if (recordget.exists()) {
                // console.log("Stock data:", recordget.data()["totalMintStock"]);
                //get DocumentReference from collection database
                // const colRefget = doc(
                //   db,
                //   process.env.REACT_APP_FIREBASE_COLLECTION,
                //   wallet.publicKey.toBase58()
                // );
                // const recordget = await getDoc(colRefget);

                //refresh account
                let dbFirst = recordget.data()["firstPass"];
                let dbSecond = recordget.data()["secondPass"];
                let dbThird = recordget.data()["thirdPass"];

                // latest variable
                let latestFirst = 0;
                let latestTotalFirst = 0;
                let latestSecond = 0;
                let latestTotalSecond = 0;
                let latestThird = 0;
                let latestTotalThird = 0;
                let latestTotal = 0;
                let latestTotalPass = 0;
                let latestTotalMintStock = 0;

                //define and update latest pass
                if (first !== dbFirst) {
                  latestFirst = first;
                  latestTotalFirst = latestFirst * 10;
                  console.log(latestFirst);
                  // const walletDoc = doc(
                  //   db,
                  //   process.env.REACT_APP_FIREBASE_COLLECTION,
                  //   wallet.publicKey.toBase58()
                  // );
                  const newStock = {
                    firstPass: latestFirst,
                    firstTotal: latestTotalFirst,
                  };
                  await updateDoc(colRefget, newStock);
                  console.log("update single pass succeded");
                }
                if (second !== dbSecond) {
                  latestSecond = second;
                  latestTotalSecond = latestSecond * 3;
                  console.log(latestSecond);
                  // const walletDoc = doc(
                  //   db,
                  //   process.env.REACT_APP_FIREBASE_COLLECTION,
                  //   wallet.publicKey.toBase58()
                  // );
                  const newStock = {
                    secondPass: latestSecond,
                    secondTotal: latestTotalSecond,
                  };
                  await updateDoc(colRefget, newStock);
                  console.log("update single pass succeded");
                }
                if (third !== dbThird) {
                  latestThird = third;
                  latestTotalThird = latestThird * 1;
                  console.log(latestThird);
                  // const walletDoc = doc(
                  //   db,
                  //   process.env.REACT_APP_FIREBASE_COLLECTION,
                  //   wallet.publicKey.toBase58()
                  // );
                  const newStock = {
                    thirdPass: latestThird,
                    thirdTotal: latestTotalThird,
                  };
                  await updateDoc(colRefget, newStock);
                  console.log("update single pass succeded");
                }

                // define latest total mint stock
                if (latestTotalFirst === 0) {
                  latestTotalFirst = recordget.data()["firstTotal"];
                }
                if (latestTotalSecond === 0) {
                  latestTotalSecond = recordget.data()["secondTotal"];
                }
                if (latestTotalThird === 0) {
                  latestTotalThird = recordget.data()["thirdTotal"];
                }

                // define latest total pass
                if (latestFirst === 0) {
                  latestFirst = recordget.data()["firstPass"];
                }
                if (latestSecond === 0) {
                  latestSecond = recordget.data()["secondPass"];
                }
                if (latestThird === 0) {
                  latestThird = recordget.data()["thirdPass"];
                }

                //update latest total pass and total mint stock
                latestTotalPass = latestFirst + latestSecond + latestThird;
                latestTotal =
                  latestTotalFirst + latestTotalSecond + latestTotalThird;
                console.log(latestTotal);
                latestTotalMintStock =
                  latestTotal - recordget.data()["stockMint"];
                console.log(latestTotalMintStock);
                // const walletDoc = doc(
                //   db,
                //   process.env.REACT_APP_FIREBASE_COLLECTION,
                //   wallet.publicKey.toBase58()
                // );
                const newStock = {
                  totalPass: latestTotalPass,
                  totalMintStock: latestTotalMintStock,
                };
                await updateDoc(colRefget, newStock);
                console.log("all stock updated");
                if (
                  latestTotalMintStock !== recordget.data()["totalMintStock"]
                ) {
                  latestTotalMintStock = latestTotalMintStock;
                }
                updateWalletToDb(
                  latestTotalMintStock,
                  recordget.data()["stockMint"],
                  wallet.publicKey.toBase58()
                );
                console.log("update wallet");
                setIsTotalMint(recordget.data()["totalMintStock"]);
                console.log("minting success");
              } else {
                console.log("No such stock available!");
              }
            }
          } else {
            setAlertState({
              open: true,
              message: "Mint failed! Please try again!",
              severity: "error",
            });
          }
        } else {
          setAlertState({
            open: true,
            message: "You don't have any Pass, let's start buy a Pass first!",
            severity: "error",
          });
        }
      }
    } catch (error: any) {
      // TODO: blech:
      let message = error.msg || "Minting failed! Please try again!";
      if (!error.msg) {
        if (!error.message) {
          message = "Transaction Timeout! Please try again.";
        } else if (error.message.indexOf("0x138")) {
        } else if (error.message.indexOf("0x137")) {
          message = `SOLD OUT!`;
        } else if (error.message.indexOf("0x135")) {
          message = `Insufficient funds to mint. Please fund your wallet.`;
        }
      } else {
        if (error.code === 311) {
          message = `SOLD OUT!`;
        } else if (error.code === 312) {
          message = `Minting period hasn't started yet.`;
        }
      }

      setAlertState({
        open: true,
        message,
        severity: "error",
      });
    } finally {
      setIsMinting(false);
    }
  };

  useEffect(() => {
    (async () => {
      if (walletNetwork) {
        if (wallet) {
          let getMint = await getMintAddress();
          let firstC = 0;
          let secondC = 0;
          let thirdC = 0;
          let totalC = 0;

          if (getMint[0] !== undefined) {
            getMint.forEach(async (data) => {
              if (data.data.name.includes("Abstract Labs Inner Circle")) {
                firstC = firstC += 1;
              } else if (data.data.name.includes("Abstract Labs Centurion")) {
                secondC = secondC += 1;
              } else if (data.data.name.includes("Abstract Labs Standard")) {
                thirdC = thirdC += 1;
              }
            });
          }

          totalC = firstC + secondC + thirdC;

          if (totalC === 0) {
            setIsBuyFirst(true);
          }

          const balance = await props.connection.getBalance(wallet.publicKey);
          setBalance(balance / LAMPORTS_PER_SOL);
          // checkPass(total);
          const colRefget = doc(db, process.env.REACT_APP_FIREBASE_COLLECTION, wallet.publicKey.toBase58());
          const recordget = await getDoc(colRefget);
          if (recordget.exists()) {
            setIsTotalMint(recordget.data()["totalMintStock"]);

            // const data = await getDocs(nixWalletColRef);
            // const spec = data.docs.map((doc) => ({
            //   ...doc.data(),
            //   id: doc.id,
            // }));
            // console.log(spec);
            var condition = false;
            console.log("wallet active : " + wallet.publicKey.toBase58());

            //Check if wallet address is available in database
            // if (spec !== undefined) {
            //   spec.forEach(async (data) => {
            var check =
              recordget.data()["walletAddress"] === wallet.publicKey.toBase58();
            // var check = data["walletAddress"] === wallet.publicKey.toBase58();
            if (check === true) {
              condition = true;
            }
            // });
            // }

            console.log("final condition : " + condition);
            let getMint = await getMintAddress();
            let first = 0;
            let second = 0;
            let third = 0;
            let firstTotal = 0;
            let secondTotal = 0;
            let thirdTotal = 0;
            let total = 0;
            let totalAvailableMint = 0;
            let stockMint = 0;

            if (getMint[0] !== undefined) {
              getMint.forEach(async (data) => {
                if (data.data.name.includes("Abstract Labs Inner Circle")) {
                  first = first += 1;
                } else if (data.data.name.includes("Abstract Labs Centurion")) {
                  second = second += 1;
                } else if (data.data.name.includes("Abstract Labs Standard")) {
                  third = third += 1;
                }
              });
            }

            firstTotal = first * 10;
            secondTotal = second * 3;
            thirdTotal = third * 1;
            total = first + second + third;
            totalAvailableMint = firstTotal + secondTotal + thirdTotal;
            // const colRef = doc(db, process.env.REACT_APP_FIREBASE_COLLECTION, wallet.publicKey.toBase58());
            const equalMintStock = total === totalAvailableMint;
            if (condition !== false) {
              if (equalMintStock !== false) {
                // console.log(totalAvailableMint);
                // console.log(equalMintStock);
                const addWalletToDb = async (
                  walletAddress,
                  firstPass,
                  firstTotal,
                  secondPass,
                  secondTotal,
                  thirdPass,
                  thirdTotal,
                  totalPass,
                  totalMintStock,
                  stockMint
                ) => {
                  await setDoc(colRefget, {
                    walletAddress: walletAddress,
                    firstPass: firstPass,
                    firstTotal: firstTotal,
                    secondPass: secondPass,
                    secondTotal: secondTotal,
                    thirdPass: thirdPass,
                    thirdTotal: thirdTotal,
                    totalPass: totalPass,
                    totalMintStock: totalMintStock,
                    stockMint: stockMint,
                  });
                };
                addWalletToDb(
                  wallet.publicKey.toBase58(),
                  first,
                  firstTotal,
                  second,
                  secondTotal,
                  third,
                  thirdTotal,
                  total,
                  totalAvailableMint,
                  stockMint
                );
                console.log("set success");
                setIsTotalMint(totalAvailableMint.toString());
              } else {
                console.log("nothing changes");
              }
            }
          } else if (totalC !== 0) {
            setIsTotalMint(getTotalPass.toString());
            // console.log("wallet active : " + wallet.publicKey.toBase58());

            let getMint = await getMintAddress();
            let first = 0;
            let second = 0;
            let third = 0;
            let firstTotal = 0;
            let secondTotal = 0;
            let thirdTotal = 0;
            let total = 0;
            let totalAvailableMint = 0;
            let stockMint = 0;

            if (getMint[0] !== undefined) {
              getMint.forEach(async (data) => {
                if (data.data.name.includes("Abstract Labs Inner Circle")) {
                  first = first += 1;
                } else if (data.data.name.includes("Abstract Labs Centurion")) {
                  second = second += 1;
                } else if (data.data.name.includes("Abstract Labs Standard")) {
                  third = third += 1;
                }
              });
            }

            firstTotal = first * 10;
            secondTotal = second * 3;
            thirdTotal = third * 1;
            total = first + second + third;
            totalAvailableMint = firstTotal + secondTotal + thirdTotal;
            // const colRef = doc(db, process.env.REACT_APP_FIREBASE_COLLECTION, wallet.publicKey.toBase58());

            const addWalletToDb = async (
              walletAddress,
              firstPass,
              firstTotal,
              secondPass,
              secondTotal,
              thirdPass,
              thirdTotal,
              totalPass,
              totalMintStock,
              stockMint
            ) => {
              await setDoc(colRefget, {
                walletAddress: walletAddress,
                firstPass: firstPass,
                firstTotal: firstTotal,
                secondPass: secondPass,
                secondTotal: secondTotal,
                thirdPass: thirdPass,
                thirdTotal: thirdTotal,
                totalPass: totalPass,
                totalMintStock: totalMintStock,
                stockMint: stockMint,
              });
              console.log("create new success");
            };
            addWalletToDb(
              wallet.publicKey.toBase58(),
              first,
              firstTotal,
              second,
              secondTotal,
              third,
              thirdTotal,
              total,
              totalAvailableMint,
              stockMint
            );
          }
        }
      }
    })();
  }, [wallet, props.connection, setIsTotalMint]);

  useEffect(refreshCandyMachineState, [
    wallet,
    props.candyMachineId,
    props.connection,
    isEnded,
    isPresale,
  ]);

  const config = {
    type: "spring",
    stiffness: 70,
  };

  return (
    <main>
      <motion.div
        transition={config}
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ x: 0, opacity: 0 }}
        className="inline"
      >
        <MainContainer>
          <WalletContainer>
            <Logo><a href="http://abstractlabs.art" target="_blank" rel="noopener noreferrer"><img alt="" src="logo-dark.png" /></a></Logo>
            <Menu />
            <Wallet className={click ? "nav-menu active" : "nav-menu"}>
              <li className="nav-item">
                {wallet ?
                  <WalletAmount>{(balance || 0).toLocaleString()} SOL<ConnectButton /></WalletAmount> :
                  <ConnectButton>SELECT WALLET → </ConnectButton>}
              </li>
              <Social>
                <SocialIcon
                  url="https://twitter.com/AbstractLabs"
                  target="_blank"
                  network="twitter"
                  fgColor="var(--main-background-color)"
                  bgColor="var(--main-text-color)"
                  style={{ height: 50, width: 50 }}
                  className="socialfooter "
                />
                <SocialIcon
                  url="http://discord.gg/RzcSqNnVz4"
                  target="_blank"
                  network="discord"
                  fgColor="var(--main-background-color)"
                  bgColor="var(--main-text-color)"
                  className="socialfooter "
                  style={{ height: 50, width: 50 }}
                />
              </Social>
            </Wallet>
            <div className="nav-icon" onClick={handleClick}>
              {click ? <FontAwesomeIcon icon={faTimes} /> : <FontAwesomeIcon icon={faBars} />}
            </div>
          </WalletContainer>
          <br />
          <MintContainer>
            <DesContainer>
              <NFT elevation={0}>
                <br />
                <div>
                  <Image
                    src="/assets/NFT.gif"
                    alt="NFT To Mint" /></div>
                <br />

                {wallet && isActive &&
                  <h3>TOTAL MINTED : {itemsRedeemed - 16} / {itemsAvailable - 15}</h3>}
                {wallet && isActive &&
                  <BorderLinearProgress variant="determinate"
                    value={99 - ((itemsRemaining * 100) / (itemsAvailable - 15))} />}
                <br />
              </NFT>
            </DesContainer>
            <DesContainer>
              <Des elevation={0}>
                <ShimmerTitle>Cyberpunk Cities</ShimmerTitle>
                <h2>Cyberpunk Cities by Oleg Zavorotnyi is a collection of artificial intelligence art. Oleg developed his custom abstract style based on trendy neural generative adversarial network algorithms, which use complex text prompts to produce images. Each Cyberpunk Cities piece is a result of an in-depth exploration of neural aesthetics - browsing through dozens of parameters, texts prompts, and accurate mixing of many generated images. This collection is an interesting way to travel through time, to feel the attractive cyberpunk atmosphere in well-known cities from around the world.
                </h2>
              </Des>
              <MintButtonContainer>
                <br />
                {!isActive &&
                  !isEnded &&
                  // !isBuyFirst &&
                  candyMachine?.state.goLiveDate &&
                  (!isWLOnly || whitelistTokenBalance > 0) ? (
                  <Countdown
                    date={toDate(candyMachine?.state.goLiveDate)}
                    onMount={({ completed }) =>
                      completed && setIsActive(!isEnded)
                    }
                    onComplete={() => {
                      setIsActive(!isEnded);
                    }}
                    renderer={renderGoLiveDateCounter}
                  />
                ) : isBuyFirst ? (
                  <>
                    <h4>You don't have Abstract Labs Pass</h4>
                    <br />
                    <BuyButtonCont href="https://magiceden.io/creators/abstract_labs" target="_blank"><BuyButton >
                      <img src="assets/me-logo.png" alt="" width={40} /> Buy on Magic Eden
                    </BuyButton></BuyButtonCont>
                  </>
                ) : !wallet ? (
                  <ConnectButton>CONNECT</ConnectButton>
                ) : !isWLOnly || whitelistTokenBalance > 0 ? (
                  candyMachine?.state.gatekeeper &&
                    wallet.publicKey &&
                    wallet.signTransaction ? (
                    <GatewayProvider
                      wallet={{
                        publicKey:
                          wallet.publicKey ||
                          new PublicKey(CANDY_MACHINE_PROGRAM),
                        //@ts-ignore
                        signTransaction: wallet.signTransaction,
                      }}
                      // // Replace with following when added
                      // gatekeeperNetwork={candyMachine.state.gatekeeper_network}
                      gatekeeperNetwork={
                        candyMachine?.state?.gatekeeper?.gatekeeperNetwork
                      } // This is the ignite (captcha) network
                      /// Don't need this for mainnet
                      clusterUrl={rpcUrl}
                      options={{ autoShowModal: false }}
                    >
                      <h4>You Have {isTotalMint} Mint Available</h4>
                      <br />
                      <MintButton
                        candyMachine={candyMachine}
                        isMinting={isMinting}
                        isActive={isActive}
                        isEnded={isEnded}
                        isSoldOut={isSoldOut}
                        onMint={onMint}
                        wallet={wallet.publicKey.toBase58()}
                      />
                    </GatewayProvider>
                  ) : (
                    <>
                      <h4>You Have {isTotalMint} Mint Available</h4>
                      <br />
                      <MintButton
                        candyMachine={candyMachine}
                        isMinting={isMinting}
                        isActive={isActive}
                        isEnded={isEnded}
                        isSoldOut={isSoldOut}
                        onMint={onMint}
                        wallet={wallet.publicKey.toBase58()}
                      />
                    </>
                  )
                ) : (
                  <h1> </h1>
                )}
              </MintButtonContainer>
              <br />
              {wallet && isActive && solanaExplorerLink && (
                <SolExplorerLink href={solanaExplorerLink} target="_blank">
                  View on Solscan
                </SolExplorerLink>
              )}

            </DesContainer>
          </MintContainer>
        </MainContainer>
        <Slide />
        {/* <Footer /> */}
        <FooterContainer>
          <h3>Abstract Labs © 2022</h3>
        </FooterContainer>
        <Snackbar
          open={alertState.open}
          autoHideDuration={6000}
          onClose={() => setAlertState({ ...alertState, open: false })}
        >
          <Alert
            onClose={() => setAlertState({ ...alertState, open: false })}
            severity={alertState.severity}
          >
            {alertState.message}
          </Alert>
        </Snackbar>
      </motion.div>
    </main>
  );
};

export default Home;
